export const CambridgeTheatre = {
  basketNote: {},
  colors: {
    venueLogoBackgroundColor: '#7db9e1'
  },
  themeVenueLogo: 'cambridge_sw_icon.png',
  themeVenueName: 'Cambridge Theatre',
  themeVenueAddress: 'Earlham Street, Seven Dials, London WC2H 9HU'
}
